import React, { useState } from "react";
import "./contact.less";
import axios from "axios";
import { toast } from "react-toastify";

const Contact: React.FC = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  // Base API URL from Vite env:
  const BASE_URL = import.meta.env.VITE_API_URL;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await axios.post(`${BASE_URL}/user/contact`, form);

      toast.success("Message sent successfully!");

      // Reset form
      setForm({
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
      });
    } catch (error) {
      toast.error("Failed to submit form");
    }
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact__hero">
        <div className="contact__hero-text">
          <h1>
            Contact <span>us</span>
          </h1>
          <p>
            Have a query or need support? Reach out and our team will be happy
            to assist you.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="contact__content">
        <div className="contact__content-left">
          <div className="contact__content-left__box contact__content-left__box--info">
            <h3 className="contact__content-left__box--title">
              Office <span>Info</span>
            </h3>
            <p className="title">CARE Analytics and Advisory Private Limited</p>
            <p>A subsidiary of CARE Ratings Limited</p>
            <p>
              <strong>CIN:</strong> U74210MH1999PTC118349
            </p>
          </div>

          <div className="contact__content-left__box contact__content-left__box--address">
            <h3 className="contact__content-left__box--title">
              Office <span>Address</span>
            </h3>
            <p>
              9th Floor, Tropical New Era Business Park,
              <br />
              Road No. 33, Wagle Industrial Estate,
              <br />
              Opp ESIS Kamagar Hospital,
              <br />
              Thane West, Thane, 400604.
            </p>
            <p>
              <strong>Email:</strong> caaplanalytics.sales@careedge.in
            </p>
            <p>
              <strong>Phone:</strong> +91 22 6174 8900
            </p>
          </div>
        </div>

        {/* Business Enquiry Section */}
        <div className="contact__content-right">
          <div className="contact__content-right__enquiry">
            <h3>
              Business <span>Enquiry</span>
            </h3>

            <form
              className="contact__content-right__form"
              onSubmit={handleSubmit}
            >
              <div className="contact__content-right__form-row">
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    name="name"
                    type="text"
                    placeholder="Enter your full name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="contact__content-right__form-row">
                <div className="form-group">
                  <label>Mobile Number</label>
                  <input
                    name="phone"
                    type="text"
                    placeholder="Enter mobile number"
                    value={form.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Company Name</label>
                  <input
                    name="company"
                    type="text"
                    placeholder="Enter company name"
                    value={form.company}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="contact__content-right__form-row">
                <div className="form-group form-group--full">
                  <label>Message</label>
                  <textarea
                    name="message"
                    placeholder="Write your message.."
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
              </div>

              <button type="submit" className="contact__content-right__submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
